import { MONTH, WEEK, YEAR, DEFAULT_EVENT_OPACITY } from "../constants"
import { makeTransparent } from "./eventToItem"

export const snapToGrid = (date, snapUnit) => {
  const getClosestDate = (date, date0, date1) => {
    return date.diff(date0) < date1.diff(date) ? date0 : date1
  }

  const roundDate = (date, unit) => {
    const date0 = date.clone().startOf(unit)
    const date1 = date0.clone().add(1, unit)

    return getClosestDate(date, date0, date1)
  }

  if (snapUnit) {
    return roundDate(date, snapUnit)
  }
  return date
}

const snapUnitWeights = {
  month: 3,
  day: 2,
  hour: 1,
}

export const snapUnits = {
  month: `month`,
  day: `day`,
  hour: `hour`,
}

export const getGreaterSnapUnit = (snapUnit1, snapUnit2) => {
  const weight1 = snapUnitWeights[snapUnit1]
  const weight2 = snapUnitWeights[snapUnit2]
  const isWeight1Valid = typeof weight1 === `number`
  const isWeight2Valid = typeof weight2 === `number`

  if (!isWeight1Valid && isWeight2Valid) {
    return snapUnit2
  }

  if (isWeight1Valid && !isWeight2Valid) {
    return snapUnit1
  }

  if (!isWeight1Valid && !isWeight2Valid) {
    return null
  }

  if (weight1 > weight2) {
    return snapUnit1
  }
  return snapUnit2
}

export const getSnapUnit = scale => {
  switch (scale) {
    case YEAR:
      return `month`
    case MONTH:
      return `day`
    case WEEK:
      return `hour`
    default:
      return null
  }
}

export const makeTransparentWithWhite = hex => {
  const color = makeTransparent(hex, DEFAULT_EVENT_OPACITY)
  return `linear-gradient(${color}, ${color}), linear-gradient(white, white)`
}

export const limitDate = (date, minDate, maxDate) => {
  if (minDate && date.isBefore(minDate)) {
    return minDate
  }

  if (maxDate && date.isAfter(maxDate)) {
    return maxDate
  }

  return date
}

export const getTimeLabel = (startDate, endDate) => {
  const isDayCrossed =
    Math.abs(startDate.diff(endDate, `days`, true)) > 1 ||
    startDate.date() !== endDate.date()

  const isYearCrossed =
    Math.abs(startDate.diff(endDate, `years`, true)) > 1 ||
    startDate.year() !== endDate.year()

  const format = `${isDayCrossed ? `DD MMM ` : ``}${
    isYearCrossed ? `YYYY ` : ``
  }HH:mm`

  return `${startDate.format(format)} - ${endDate.format(format)}`
}
